import forge from 'node-forge';

const security =
{
	encode: (val) =>
	{
		var number = '0x'
		var length = val.length
		for (var i = 0; i < length; i++) { number += val.charCodeAt(i).toString(16) }
		return number
	},

	decode: (val) =>
	{
		var string = ''
		val = val.slice(2)
		var length = val.length
		for (var i = 0; i < length;)
		{
			var code = val.slice(i, i += 2)
			string += String.fromCharCode(parseInt(code, 16))
		}

		return string
	},


	aesEncrypt(str, secretKey)
	{

		const iv = forge.random.getBytesSync(12);

		const cipher = forge.cipher.createCipher('AES-GCM', forge.util.hexToBytes(secretKey));
		cipher.start({ iv: iv });
		cipher.update(forge.util.createBuffer(str, 'utf8'));
		cipher.finish();

		const encryptedBytes = cipher.output.getBytes();
		const tagBytes = cipher.mode.tag.getBytes();

		const tag = forge.util.encode64(tagBytes);
		const ivString = forge.util.encode64(iv);
		const data = forge.util.encode64(encryptedBytes);

		return {
			ivString, data, tag
		};
	},

	aesDecrypt(data, secretKey)
	{
		const iv = forge.util.decode64(data.ivString);
		const tag = forge.util.decode64(data.tag);
		const encryptedBytes = forge.util.decode64(data.data);

		const decipher = forge.cipher.createDecipher('AES-GCM', forge.util.hexToBytes(secretKey));
		decipher.start({ iv: iv, tag: tag });
		decipher.update(forge.util.createBuffer(encryptedBytes));
		const success = decipher.finish();

		if (!success)
		{
			throw new Error('Tag verification failed - The message may have been tampered with');
		}

		return decipher.output.toString('utf8');
	}

}

export default security
